module.exports = __webpack_public_path__ + "static/media/apple.3f35bdbd.svg";